import { resolveComponent, openBlock, createBlock, withCtx, createVNode, Transition, withDirectives, mergeProps, renderSlot, createTextVNode, toDisplayString, vShow, createCommentVNode } from 'vue';

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_visually_hidden = resolveComponent("el-visually-hidden");
  const _component_el_popper_content = resolveComponent("el-popper-content");
  const _component_el_teleport = resolveComponent("el-teleport");
  return _ctx.shouldRenderTeleport ? (openBlock(), createBlock(_component_el_teleport, {
    key: 0,
    disabled: !_ctx.teleported,
    container: _ctx.POPPER_CONTAINER_SELECTOR
  }, {
    default: withCtx(() => [
      createVNode(Transition, {
        name: _ctx.transition,
        onAfterLeave: _ctx.onTransitionLeave
      }, {
        default: withCtx(() => [
          _ctx.shouldRenderPopperContent ? withDirectives((openBlock(), createBlock(_component_el_popper_content, mergeProps({
            key: 0,
            ref: "contentRef"
          }, _ctx.$attrs, {
            "aria-hidden": _ctx.ariaHidden,
            "boundaries-padding": _ctx.boundariesPadding,
            "fallback-placements": _ctx.fallbackPlacements,
            "gpu-acceleration": _ctx.gpuAcceleration,
            offset: _ctx.offset,
            placement: _ctx.placement,
            "popper-options": _ctx.popperOptions,
            strategy: _ctx.strategy,
            effect: _ctx.effect,
            enterable: _ctx.enterable,
            pure: _ctx.pure,
            "popper-class": _ctx.popperClass,
            "popper-style": [_ctx.popperStyle, _ctx.contentStyle],
            "reference-el": _ctx.referenceEl,
            "z-index": _ctx.zIndex,
            onMouseenter: _ctx.onContentEnter,
            onMouseleave: _ctx.onContentLeave
          }), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default"),
              createVNode(_component_el_visually_hidden, {
                id: _ctx.id,
                role: "tooltip"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.ariaLabel), 1)
                ]),
                _: 1
              }, 8, ["id"])
            ]),
            _: 3
          }, 16, ["aria-hidden", "boundaries-padding", "fallback-placements", "gpu-acceleration", "offset", "placement", "popper-options", "strategy", "effect", "enterable", "pure", "popper-class", "popper-style", "reference-el", "z-index", "onMouseenter", "onMouseleave"])), [
            [vShow, _ctx.shouldShowPopperContent]
          ]) : createCommentVNode("v-if", true)
        ]),
        _: 3
      }, 8, ["name", "onAfterLeave"])
    ]),
    _: 3
  }, 8, ["disabled", "container"])) : createCommentVNode("v-if", true);
}

export { render };
//# sourceMappingURL=content.vue_vue_type_template_id_20254f8d_lang.mjs.map
